"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.customerToken
  };
};

var _default = function _default(Component, path) {
  var Secured = function Secured(props) {
    return props.isAuthenticated ? React.createElement(Component, props) : React.createElement(_reactRouter.Redirect, {
      to: path
    });
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Secured);
};

exports.default = _default;